/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { MatButtonModule } from '@angular/material/button';
import { CountdownModule } from 'ngx-countdown';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnespCoreHeaderCountdownComponent } from './unesp-core-header-countdown.component';
import { FlexModule } from "@ngbracket/ngx-layout";

@NgModule({
  declarations: [
    UnespCoreHeaderCountdownComponent
  ],
  exports: [
    UnespCoreHeaderCountdownComponent
  ],
  imports: [
    CommonModule,
    CountdownModule,
    MatButtonModule,
    FlexModule
  ]
})
export class UnespCoreHeaderCountdownModule {
}
